import { UTCDate } from '@date-fns/utc';
import { format, subMonths, subWeeks } from 'date-fns';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';
import { DateRangeValue } from '../components/email-connection-modal/email-date-range-selection-form';

const FORMAT = 'yyyy-MM-dd';

const today = new UTCDate();
const minus1Week = subWeeks(today, 1);
const minus1Month = subMonths(today, 1);
const minus3Months = subMonths(today, 3);
const minus6Months = subMonths(today, 6);
const minus12Months = subMonths(today, 12);

export const getDateRangeValues = (dateRangeValue: DateRangeValue) => {
  switch (dateRangeValue) {
    case '1-week':
      return { startDate: format(minus1Week, FORMAT), endDate: format(today, FORMAT) };
    case '1-month':
      return { startDate: format(minus1Month, FORMAT), endDate: format(today, FORMAT) };
    case '3-month':
      return { startDate: format(minus3Months, FORMAT), endDate: format(today, FORMAT) };
    case '6-month':
      return { startDate: format(minus6Months, FORMAT), endDate: format(today, FORMAT) };
    case '12-month':
      return { startDate: format(minus12Months, FORMAT), endDate: format(today, FORMAT) };
    default:
      return exhaustiveCheck(dateRangeValue);
  }
};
